import { useBaseAPI } from 'apiServices/baseAPI';

export function useOrganizationAPI() {
  return useBaseAPI({
    method: 'GET',
    route: 'admin/fhir/Organization?_count=99&_elements=identifier,name,alias',
    additionalHeaders: {
      Accept: '*/*',
    },
  });
}
